import {
  SET_DOCUMENTS, UNSET_DOCUMENTS,
} from '@/vuex/modules/documents/types/mutations';

import {
  DEFINE_DOCUMENTS, CLEAR_DOCUMENTS,
} from '@/vuex/modules/documents/types/actions';

export default {
  state: {
    documents: [],
  },
  getters: {
    documents: state => state.documents || [],
    neededDocumentsCount: (state, getters) => {
      let neededCount = 0;
      getters.documents.forEach((item) => {
        neededCount = neededCount + item.neededCount || 0;
      });
      // When sign up, documents is not updated like we have on login action,
      // so returns default value for needed documents for borrowers
      if (neededCount === 0 && getters.documents.length === 0) {
        neededCount = 8;
      }
      return neededCount;
    },
  },
  mutations: {
    [SET_DOCUMENTS](state, documents) {
      state.documents = documents;
      localStorage.docs = JSON.stringify(documents);
    },
    [UNSET_DOCUMENTS](state) {
      state.documents = [];
      localStorage.removeItem('docs');
    },
  },
  actions: {
    [DEFINE_DOCUMENTS](context, playload) {
      context.commit(SET_DOCUMENTS, playload.docs);
    },
    [CLEAR_DOCUMENTS](context) {
      context.commit(UNSET_DOCUMENTS);
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/documents/index.js